export const LABELS = {
  ACTIONS: {
    NAVIGATE_TO_RECONCILIATION: ['pages.reconciliations.list.components.actions.navigateToReconciliation', 'See Details'],
    DOWNLOAD_CSV_REPORT: ['pages.reconciliations.list.components.actions.downloadCsvReport', 'Download CSV Report'],
  },
};
